/**
 * ToastLayer — pins page-level toasts to the top-right of the viewport,
 * above modals (--z-toast sits over --z-modal).
 *
 * Toast has no positioning of its own. Rendered in page flow, it lands below
 * a long dashboard's content and, while a Modal is open, under the scrim, so
 * validation and save errors raised from a dialog are never seen.
 */

import React from 'react';

interface ToastLayerProps {
  children?: React.ReactNode;
}

const ToastLayer: React.FC<ToastLayerProps> = ({ children }) => (
  <div
    role="region"
    aria-label="Notifications"
    style={{
      position: 'fixed',
      top: 20,
      right: 20,
      maxWidth: 'calc(100vw - 40px)',
      zIndex: 'var(--z-toast)' as unknown as number,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 10,
    }}
  >
    {children}
  </div>
);

export default ToastLayer;
